import { useState } from 'react';
import { useActiveWorkspace } from '@/hooks/use-active-workspace';
import { useCreateAccountWorkspace } from '@/hooks/use-account';
import { ApiError } from '@/lib/api';
import { IconChevronRight } from './sidebar-icons';
import styles from './WorkspaceSwitcher.module.scss';

export function WorkspaceSwitcher() {
  const { workspace, list, switchTo } = useActiveWorkspace();
  const [open, setOpen] = useState(false);
  const [createError, setCreateError] = useState<string | null>(null);
  const createMutation = useCreateAccountWorkspace();

  // Cria dentro da capacidade da assinatura (modelo capacity). O endpoint antigo
  // /api/workspaces exigia subscription_id e mexia no provedor de pagamento — não usar aqui.
  async function handleCreate() {
    const name = window.prompt('Nome do workspace:');
    if (!name?.trim()) return;
    setCreateError(null);
    try {
      const data = await createMutation.mutateAsync(name.trim());
      // O hook aguarda o refetch de /api/me; só então troca para o novo workspace.
      switchTo(data.workspace_id);
      setOpen(false);
    } catch (error) {
      setCreateError(error instanceof ApiError ? error.message : 'Não foi possível criar o workspace. Tente novamente.');
    }
  }

  return (
    <div className={styles.root}>
      <button
        className={styles.trigger}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls="workspace-switcher-menu"
      >
        <span>{workspace?.name ?? 'Sem workspace'}</span>
        <span className={`${styles.chevron} ${open ? styles.chevronOpen : ''}`}>
          <IconChevronRight />
        </span>
      </button>
      {open && (
        <div id="workspace-switcher-menu" className={styles.menu}>
          {list.map((w) => (
            <button
              key={w.workspace_id}
              className={`${styles.item} ${w.workspace_id === workspace?.workspace_id ? styles.active : ''}`}
              onClick={() => { switchTo(w.workspace_id); setOpen(false); }}
            >
              {w.name}
            </button>
          ))}
          <div className={styles.separator} />
          {createError && <div className={styles.error} role="alert">{createError}</div>}
          <button className={styles.add} onClick={() => void handleCreate()} disabled={createMutation.isPending}>
            {createMutation.isPending ? 'Criando...' : '+ Novo workspace'}
          </button>
        </div>
      )}
    </div>
  );
}
